import {
    InterfaceSuccessfulImplementationStoriesTemplate
} from "../../../interface/elements-with-filter/interface.successful.implementation.stories.template";
import {webApi} from "../../consts";

export const successfulImplementationStoriesTemplateHtml = (
    units: InterfaceSuccessfulImplementationStoriesTemplate[]
) => {
    let contentResult: string = '';
    units.forEach((item: InterfaceSuccessfulImplementationStoriesTemplate) => {
        const titleWithoutSpaces = item.Header.split(' ').join('-');
        contentResult
            += `
                <a href="/история/${item.Id}/${encodeURIComponent(
                  titleWithoutSpaces.replace(/[«»<>]/g, '').replace(/\//g, '-')
                    .replace(/\./g, '')
                )}" 
                class="successful-implementation-stories__article">
                    <div class="successful-implementation-stories__article-kind-background">
                        <div class="successful-implementation-stories__article-kind-img">    
                            <img src="${webApi}${item.ImgUrl}" alt="img">
                        </div>
                        <div class="successful-implementation-stories__article-kind">
                            <h6>${item.Category.Name}</h6>
                        </div>
                    </div>
                    <h5>${item.Header}</h5>
                </a>
            `
    });
    return contentResult;
}
